/** Forgot-password — request a reset link (POST /auth/forgot-password). Public. */
import { useState, type FormEvent } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { apiForgotPassword } from "@/auth/api";
import { AuthShell, authButtonClass, authInputClass } from "@/auth/AuthShell";

export default function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await apiForgotPassword(email);
    } finally {
      // The endpoint is enumeration-safe (always 200), so the confirmation
      // shows regardless of outcome — never surface which emails exist.
      setSent(true);
      setBusy(false);
    }
  }

  return (
    <AuthShell>
      <h1 className="text-base font-semibold">{t("auth.forgotTitle")}</h1>
      {sent ? (
        <p className="text-sm text-fg-muted">{t("auth.resetSent")}</p>
      ) : (
        <form onSubmit={onSubmit} className="space-y-4">
          <p className="text-sm text-fg-muted">{t("auth.forgotHelp")}</p>
          <label className="block text-sm">
            <span className="mb-1 block text-fg-muted">{t("auth.email")}</span>
            <input
              type="email"
              required
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className={authInputClass}
            />
          </label>
          <button type="submit" disabled={busy} className={authButtonClass}>
            {busy ? "…" : t("auth.sendResetLink")}
          </button>
        </form>
      )}
      <Link to="/login" className="block text-center text-sm text-brand hover:underline">
        {t("auth.backToSignIn")}
      </Link>
    </AuthShell>
  );
}
